import { CartAPIList } from '@/api'

const api = new CartAPIList();

export default {
	createUserAddress({ state }, param) {
		return new Promise((resolve, reject) => {
			api.createUserAddress(param, (json) => {
				if (json.status !== 200) {
					reject(json.message);
				}
				resolve(json);
			}, (error) => {
				reject(error);
			})
		});
	},

	editUserAddress({ state }, param) {
		return new Promise((resolve, reject) => {
			api.editUserAddress(param, (json) => {
				if (json.status !== 200) {
					reject(json.message);
				}
				resolve(json);
			}, (error) => {
				reject(error);
			})
		});
	},

	createOrder({ state }, param) {
		return new Promise((resolve, reject) => {
			api.createOrder(param, (json) => {
				if (json.status !== 200) {
					reject(json.message);
				}
				resolve(json);
			}, (error) => {
				reject(error);
			})
		});
	},
	pay({ state }, param) {
		return new Promise((resolve, reject) => {
			api.pay(param, (json) => {
				if (json.status !== 200) {
					reject(json.message);
				}
				resolve(json);
			}, (error) => {
				reject(error);
			})
		});
	},
	getWechatConfig({ state }, param) {
		return new Promise((resolve, reject) => {
			api.getWechatConfig(param, (json) => {
				if (json.status !== 200) {
					reject(json.message);
				}
				resolve(json);
			}, (error) => {
				reject(error);
			})
		});
	},
	getOrderList({ state }, param) {
		return new Promise((resolve, reject) => {
			api.getOrderList(param, (json) => {
				if (json.status !== 200) {
					reject(json.message);
				}
				resolve(json);
			}, (error) => {
				reject(error);
			})
		});
	},

	getAuthCode({ state }, param) {
		return new Promise((resolve, reject) => {
			api.getAuthCode(param, (json) => {
				if (json.status !== 200) {
					reject(json.message);
				}
				resolve(json);
			}, (error) => {
				reject(error);
			})
		});
	},

	getWechatOpenID({ state }, param) {
		return new Promise((resolve, reject) => {
			api.getWechatOpenID(param, (json) => {
				if (json.status !== 200) {
					reject(json.message);
				}
				resolve(json);
			}, (error) => {
				reject(error);
			})
		});
	},
	wechatPay({ state }, param) {
		return new Promise((resolve, reject) => {
			api.wechatPay(param, (json) => {
				if (json.status !== 200) {
					reject(json.message);
				}
				resolve(json);
			}, (error) => {
				reject(error);
			})
		});
	},
	cancelOrder({ state }, param) {
		return new Promise((resolve, reject) => {
			api.cancelOrder(param, (json) => {
				if (json.status !== 200) {
					reject(json.message);
				}
				resolve(json);
			}, (error) => {
				reject(error);
			})
		});
	},
	setOrderStatus({ state }, param) {
		return new Promise((resolve, reject) => {
			api.setOrderStatus(param, (json) => {
				if (json.status !== 200) {
					reject(json.message);
				}
				resolve(json);
			}, (error) => {
				reject(error);
			})
		});
	},



}



// WEBPACK FOOTER //
// ./src/Cart/store/actions.js